import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { AccountModule } from '@abp/ng.account';
import { ProfileTabComponent } from '../profile-tab/profile-tab.component';
import { PaymentTabComponent } from '../payment-tab/payment-tab.component';
import { AddressesTabComponent } from '../addresses-tab/addresses-tab.component';
import { SettingTabComponent } from '../settings-tab/setting-tab.component';

/**
 * Local replacement for ABP's manage-profile page. The commercial `ManageProfileTabsService`
 * extensibility was Pro-only, so we host the tabs ourselves: Personal Info, Change Password
 * (free `abp-change-password-form`) plus the custom Payment, Addresses and Settings tabs.
 * Registered against `eAccountComponents.ManageProfile` via ReplaceableComponentsService.
 */
@Component({
    selector: 'app-manage-profile',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        CoreModule,
        ThemeSharedModule,
        AccountModule,
        ProfileTabComponent,
        PaymentTabComponent,
        AddressesTabComponent,
        SettingTabComponent,
    ],
    templateUrl: './manage-profile.component.html'
})
export class ManageProfileComponent {
  selectedTab = 0;
}
